import {
  Description,
  Field,
  Input as HeadlessUiInput,
  Label,
} from '@headlessui/react'

interface Props {
  autoComplete?: string
  autoFocus?: boolean
  description?: React.ReactNode | string
  disabled?: boolean
  invalid?: boolean
  label?: string
  name?: string
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void
  placeholder?: string
  type?: string
  value?: string
  dataTestId?: string
  bgColor?: string
}

export default function Input({
  autoComplete,
  autoFocus = false,
  description,
  disabled = false,
  invalid = false,
  label,
  name,
  onChange,
  placeholder = '',
  type = 'text',
  value,
  dataTestId,
  bgColor = 'bg-transparent',
}: Props) {
  return (
    <Field className="gap-y-4 text-[#A2A4AE]">
      {label && (
        <Label className={`${invalid && 'text-custom-error'} mx-7`}>
          {label}
        </Label>
      )}

      <HeadlessUiInput
        autoComplete={autoComplete}
        autoFocus={autoFocus}
        className={`data-[invalid]:border-custom-error text-custom-black border-custom-gray placeholder:text-custom-gray font-headline w-full rounded-[20px] border px-7 py-6 text-center text-3xl focus:shadow-none focus:ring-0 disabled:cursor-not-allowed disabled:opacity-50 ${bgColor}`}
        disabled={disabled}
        invalid={invalid}
        name={name}
        onChange={onChange}
        placeholder={placeholder}
        type={type}
        value={value}
        data-testid={dataTestId}
      />

      {description && (
        <Description
          className={`${invalid && 'text-custom-error'} mx-7 mt-3 text-center text-xs`}
        >
          {description}
        </Description>
      )}
    </Field>
  )
}
